import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { NextSeo } from 'next-seo'
import React, { useEffect, useState } from 'react'
import Collaborations from '../../components/360works/Collaborations'
import Commercial from '../../components/360works/Commercial'
import Offers from '../../components/360works/Offers'
import Overview from '../../components/360works/Overview'
import Services from '../../components/360works/Services'
import Testimonials from '../../components/360works/Testimonials'
import CommonBanner from '../../components/common/CommonBanner'
import Tomorrow from '../../components/home/Tomorrow'
import { QueryClient, useQuery, dehydrate } from "react-query";
import { BASE_URL, fetchData } from "../../utils/FetchData";
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import LoadingPage from '../../components/LoadingPage'
import Footer from '@/components/common/Footer'

const Index = () => {
    const { locale } = useRouter()
    const [worksData, setWorksData] = useState();
    const { t } = useTranslation("common");
    const { data, isSuccess, isLoading, isError, isFetching } = useQuery(["360works", locale], () =>
        fetchData(
            "work",
            locale,
            "populate[0]=Banner.img_desktop&populate[1]=Banner.img_mobile&populate[2]=Overview&populate[3]=Finishes.Our_Finishes.Img_Desktop&populate[4]=Finishes.Our_Finishes.Img_Mobile&populate[5]=Commercial_Finishes.Our_Commercial.Img_Desktop&populate[6]=Commercial_Finishes.Our_Commercial.Img_Mobile&populate[7]=Collaborations.Our_Collaborations.Img_Desktop&populate[8]=Collaborations.Our_Collaborations.Img_Mobile&populate[9]=Collaborations.Our_Collaborations.Logo&populate[10]=Offers.Our_Offers.Img_Desktop&populate[11]=Offers.Our_Offers.Img_Mobile&populate[12]=Testimonials.Our_Testimonials.Personal_Img_Desktop&populate[13]=Testimonials.Our_Testimonials.Personal_Img_Mobile&populate[14]=SEO.Img&populate[15]=Finishes.Our_Finishes.pdf"
        )
    );
    useEffect(() => {
        isSuccess && setWorksData(data?.data?.attributes)
    }, [data, isSuccess])

    const [pageLoading, setPageLoading] = useState(true)
    useEffect(() => {
        let timeOut = ''
        setPageLoading(true)
        if (!isLoading) {
            timeOut = setTimeout(() => {
                setPageLoading(false)
            }, 2500)
        }
        return () => clearTimeout(timeOut)
    }, [isLoading])

    // if (pageLoading) {
    //     return <LoadingPage />;
    // }
    if (data?.error?.status == 404 || isError) {
        return <LoadingPage error />;
    }
    return (
        <>
           <NextSeo
				title={data?.data?.attributes?.SEO?.Title}
				description={data?.data?.attributes?.SEO?.Description}
				openGraph={{
					type: 'website',
					url: 'https://www.hydeparkdevelopments.com/360-works',
					title: data?.data?.attributes?.SEO?.Title,
					images: [
						{ url: BASE_URL + data?.data?.attributes?.SEO?.Img?.data?.attributes?.url },
					],
					siteName: 'Hyde Park Developments',
				}}
			/>
            <LoadingPage pageLoading={pageLoading} />
            <CommonBanner bannerData={worksData?.Banner} pageLoading={pageLoading} />
            <Overview overviewData={worksData?.Overview} />
            <Services servicesData={worksData?.Finishes} servicesHeader={worksData?.Servies_Header} />
            {/* <Commercial commercialData={worksData?.Commercial_Finishes} /> */}
            <Collaborations collaborations={worksData?.Collaborations} />
            <div className='offers-test-sections'>
                {worksData?.Offers && <Offers offersData={worksData?.Offers} />}
                <Testimonials testimonialsData={worksData?.Testimonials} />
            </div>
            <Tomorrow />
            {worksData && <Footer />}
        </>
    )
}

export default Index
export async function getServerSideProps({ locale }) {
    const queryClient = new QueryClient()
    await queryClient.prefetchQuery(["360works", locale], () =>
        fetchData(
            "work",
            locale,
            "populate[0]=Banner.img_desktop&populate[1]=Banner.img_mobile&populate[2]=Overview&populate[3]=Finishes.Our_Finishes.Img_Desktop&populate[4]=Finishes.Our_Finishes.Img_Mobile&populate[5]=Commercial_Finishes.Our_Commercial.Img_Desktop&populate[6]=Commercial_Finishes.Our_Commercial.Img_Mobile&populate[7]=Collaborations.Our_Collaborations.Img_Desktop&populate[8]=Collaborations.Our_Collaborations.Img_Mobile&populate[9]=Collaborations.Our_Collaborations.Logo&populate[10]=Offers.Our_Offers.Img_Desktop&populate[11]=Offers.Our_Offers.Img_Mobile&populate[12]=Testimonials.Our_Testimonials.Personal_Img_Desktop&populate[13]=Testimonials.Our_Testimonials.Personal_Img_Mobile&populate[14]=SEO.Img&populate[15]=Finishes.Our_Finishes.pdf"
        ))
    return {
        props: {
            dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
            ...(await serverSideTranslations(locale, ["common"])),
        },
    };
}